/**
 * 云 API 请求封装
 */


import Model from './model'
var $ = window.$;
var nohup = function () { };
import appUtil from '../lib/appUtil';

import manager from './manager';

var keyFn = function (data) { return $.param(data) }

//参数相同的请求合并成一个
var pendingCache = function (data, opts, promiseGen) {

    //使用老式回调不做处理
    if (opts.success == nohup && opts.fail == nohup && opts.combine) {
        return duplicatePromiseCombine(promiseGen, keyFn).apply(this, arguments)
    } else {
        return promiseGen()
    }
}

//通用 promise 合并
var duplicatePromiseCombine = function () {
    var pendings = {}

    /**
     * @param {Function} promiseFn 原始的 promise 方法
     * @param {Function} keyGenFn 相同的 promise 通过该方法应该返回相同的 key
     * @return {Function} 可合并相同 key promise 的方法
     * @author justanzhu
     */
    return function (promiseFn, keyGenFn) {
        return function () {
            var key = keyGenFn.apply(null, arguments)

            if (pendings[key]) {
                return pendings[key].then(function (data) {
                    // 某个回调可能直接修改该数据
                    return appUtil.clone(data)
                })
            } else {
                pendings[key] = promiseFn.apply(this, arguments)

                return pendings[key].then(function (data) {
                    delete pendings[key]
                    return data
                }, function (err) {
                    delete pendings[key]
                    throw err
                })
            }
        }
    }
}()

//简易缓存
var cacher = function () {
    var caches = {}

    //更新缓存
    function update(key, data, opts) {
        var group = caches[opts.cacheTag]
        var cache = group[key]

        if (cache) {
            clearTimeout(cache.timer)
        }

        var timer = setTimeout(function () {
            if (cache) {
                clearTimeout(cache.timer)
                delete group[key]
            }
        }, opts.expire * 60000)

        group[key] = {
            data: appUtil.clone(data),
            timer: timer,
            timeStamp: Date.now(),
            expire: opts.expire
        }
    }

    return function (data, opts, promiseGen) {
        var key = $.param(data)
        var promise
        var cache
        if (!caches[opts.cacheTag]) {
            caches[opts.cacheTag] = {}
        }

        if (opts.success == nohup && opts.fail == nohup && opts.cache) {
            //缓存处理

            if (opts.flush) {
                for (var _key in caches[opts.cacheTag]) {
                    clearTimeout(caches[opts.cacheTag][_key].timer)
                }
                caches[opts.cacheTag] = {}
            }

            cache = caches[opts.cacheTag][key]

            if (cache) {
                promise = Promise.resolve(appUtil.clone(cache.data))
            } else {
                promise = promiseGen()
                promise.then(function (data) {
                    update(key, data, opts)
                })
            }
        } else {
            //正常请求

            promise = promiseGen()

            //请求数据时, 如果发现有缓存也顺便更新下缓存
            if (caches[opts.cacheTag][key]) {
                promise.then(function (data) {
                    update(key, data, opts)
                })
            }
        }


        return promise
    }
}();

/**
 * api 请求的 promise 封装
 * @param data 请求参数
 * @exmample
 * ```
 * api.request({
 *  regionId: 1,
 *  serviceType: 'dfw',
 *  cmd: 'DescribeSecurityGroups',
 *  data: {}
 * })
 * ```
 * @param [options] 原始 model.request 的请求参数. 参考 nmc/main/model 里的 request
 * @param options.combine=true  同一时间相同参数的请求是否合并
 * @param options.secure=false   是否高安全性云 API 请求，需要进行 MFA 验证的云 API 必须指定 secure=true 
 * @returns {Window.Promise}
 */
function request(data, options) {
    console.log('data--->', data)
    options = options || {}
    var opts = $.extend({
        success: nohup,
        fail: nohup,
        name: 'delegateCApi',
        data: data,

        cache: false, //是否缓存相同参数的请求
        cacheTag: '', //缓存分组
        flush: false, //清除分组缓存, 重新拉取并数据
        expire: 5, //缓存时间 (分钟)

        combine: true,
        secure: false
    }, options);

    var _success = opts.success,
        _fail = opts.fail;

    return cacher(data, opts, function () {
        return pendingCache(data, opts, function () {
            return new Promise(function (resolve, reject) {
                var success = function (data) {
                    _success.call(this, data);
                    resolve(data);
                };
                var fail = function (err) {
                    _fail.apply(this, arguments);
                    reject(err);
                };
                var url = '/capi?cmd=' + data.cmd + "&action=delegate&serviceType=" + data.serviceType;
                if (opts.secure) {
                    url += '&secure=1';
                }
                if (opts.version) {
                    url += '&version=' + opts.version;
                }
                manager.getAllWhiteList(function (whitelist) {
                    if (opts.secure && whitelist.CONSOLE_STS_WHITE && whitelist.CONSOLE_STS_WHITE.length) {
                        url += '&sts=1';
                    }
                    var model = new Model({
                        delegateCApi: {
                            url: url,
                            method: 'post'
                        }
                    }, '/cgi');
                    model.request($.extend({}, opts, { success: success, fail: fail }))
                });
            });
        });
    });
};

let req = request;



export { req, request, duplicatePromiseCombine }

